import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DataTablesSettings, TipoRevision } from 'src/app/types/type';
import { CrudHttp } from 'src/app/helpers/CrudHttp';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TipoRevisionesService } from 'src/app/services/configuracion/tipo-revisiones.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
declare var $: any;

@Component({
  selector: 'app-tipo-revisiones',
  templateUrl: './tipo-revisiones.component.html',
  styleUrls: ['./tipo-revisiones.component.css']
})
export class TipoRevisionesComponent {
  title: string;
  subMenus: any;
  listTipoRevisiones: TipoRevision[];
  crud: CrudHttp;
  dtOptions: DataTablesSettings;
  idEmpleado: number;
  form: FormGroup;
  btnSaveRevision = false;

  constructor(
      private tipoRevisionesService: TipoRevisionesService,
      private userService: UsuariosService,
      private formBuilder: FormBuilder,
      private router: Router,
      private http: HttpClient
    ) {
    this.title = 'Configuración de tipos de revisiones';
    this.form = this.formBuilder.group({
      nombreRevision: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(128)]],
    });
    let crud = new CrudHttp(this.http);
    crud.methodGet = 'GetTipoRevisionesConfiguracion';
    crud.methodPost = 'SetTipoRevision';
    crud.methodPut = 'UpdateTipoRevision';
    crud.methodDelete = 'DeleteTipoRevision';
    this.crud = crud;
  }

  async ngOnInit() {
    this.loadSubMenu();
    this.idEmpleado = (await this.userService.getUsuario()).IdEmpleado;
    this.tipoRevisionesService.getTipoRevisionesConfiguracion(this.idEmpleado)
    .subscribe(resp => {
      if (resp.Result.Exito) {
        this.listTipoRevisiones = resp.Result.Data as TipoRevision[]
      }
    });
  }

  checklistClick(idTipoRevision) {
    this.router.navigate(['Configuracion/ChecklistConfiguracion', idTipoRevision]);
  };

  estatusClick(item) {
    item.IdEstatus = item.IdEstatus ? 0 : 1;
    item.FechaAlta = null;
    let obj = {
      t: item
    };
    this.crud.put(obj)
      .then(() => {
        Utilerias.showLoader(false)
      });
  }


  editClick(item) {
    localStorage['IdTipoRevisionEdit'] = item.IdTipoRevision;
    $('#textEdit').val(item.Descripcion);
    $('#cbEdit').attr('Checked', item.IdEstatus ? true : false);
  }


  deleteClick(id) {
    Utilerias.alertConfirm('¿Deseas eliminar el tipo de revisión?')
      .then(res => {
        if (res.value) {
          this.crud.delete({ idTipoRevision: id })
            .then(() => {
              this.listTipoRevisiones = this.listTipoRevisiones.filter(x => x.IdTipoRevision != id);
              Utilerias.showLoader(false);
            });
        }
      });
  }

  nuevaTipoRevision() {
    this.btnSaveRevision = true;
    if (this.form.valid) {
      const {
        nombreRevision
      } = this.form.value;          

      this.tipoRevisionesService.setTipoRevision(nombreRevision, this.idEmpleado)
      .subscribe(resp => {
        if (resp.Result.Data) {
          this.listTipoRevisiones.unshift(resp.Result.Data as TipoRevision)
          this.form.reset();
          this.btnSaveRevision = false;
        }
      });      
    }
  }

  frmEdit(e: Event) {
    e.preventDefault();
    var id = parseInt(localStorage['IdTipoRevisionEdit']);
    var data = {
      IdTipoRevision: id,
      Descripcion: $('#textEdit').val(),
      IdEstatus: $('#cbEdit')[0].checked ? 1 : 0
    }
    var obj = {
      t: data
    };
    this.crud.put(obj)
      .then(() => {
        let temp = this.listTipoRevisiones.find(x => x.IdTipoRevision == id);
        temp.Descripcion = data.Descripcion;
        temp.IdEstatus = data.IdEstatus;
        localStorage.removeItem('IdTipoRevisionEdit');
        Utilerias.ClearFields('#textEdit');
        //Utilerias.showLoader(false)
        $('.close').click();
      });

  }

  delete(idTipoRevision) {
    this.crud.delete(idTipoRevision)
      .then(() => { Utilerias.showLoader(false) });
  }

  loadSubMenu() {
    var items = [
      {
        active: true,
        child: false,
        label: 'Tipos de revisiones',
        class: 'submenu__item submenu--active d-flex align-items-center'
      }, {
        active: false,
        child: true,
        label: 'Usuarios',
        router: 'Usuarios',
        class: 'submenu__item d-flex align-items-center'
      }];
    this.subMenus = items;
  }
}
